export default function StatsCards() {
  const stats = [
    { label: 'Total Executions', value: '0', color: 'bg-green-500' },
    { label: 'Total Users', value: '0', color: 'bg-blue-500' },
    { label: 'Monthly Revenue', value: '$0', color: 'bg-purple-500' },
    { label: 'Active Tasks', value: '0', color: 'bg-red-500' }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div key={index} className="bg-gray-800 rounded-lg p-6">
          <div className={`${stat.color} w-12 h-12 rounded-lg mb-4 flex items-center justify-center`}>
            <span className="text-white text-xl">📊</span>
          </div>
          <h3 className="text-gray-400 text-sm">{stat.label}</h3>
          <p className="text-white text-2xl font-bold">{stat.value}</p>
        </div>
      ))}
    </div>
  );
} 